__turbopack_context__.v({
  "bottom-center": "ToastContext-module-scss-module__5Q1MGG__bottom-center",
  "bottom-left": "ToastContext-module-scss-module__5Q1MGG__bottom-left",
  "bottom-right": "ToastContext-module-scss-module__5Q1MGG__bottom-right",
  "top-center": "ToastContext-module-scss-module__5Q1MGG__top-center",
  "top-left": "ToastContext-module-scss-module__5Q1MGG__top-left",
  "top-right": "ToastContext-module-scss-module__5Q1MGG__top-right",
  "viewport": "ToastContext-module-scss-module__5Q1MGG__viewport",
});
